import * as R from 'ramda'

const notNilNorEmpty = R.complement(R.either(R.isNil, R.isEmpty))

export default notNilNorEmpty
